// 配置路由相关信息
import VueRouter from 'vue-router'
import Vue from 'vue'
import store from '../store/index'
import storage from '../utils/storage'

const Login = () => import('../views/Login.vue')
const QyLogin = () => import('../views/QyLogin.vue')
const Home = () => import('../views/Home.vue')
const Manage = () => import('../views/Manage.vue')
const Message = () => import('../views/Message.vue')
const PasswordFind = () => import('../views/PasswordFind.vue')
const Register = () => import('../views/Register.vue')
const Mine = () => import('../views/Mine.vue')

// 安装插件
Vue.use(VueRouter)


// 创建VueRouter对象
const routes = [
    {
        path: '/',
        name: 'home',
        redirect: '/home',
    },
    {
        path: '/home',
        name: 'home',
        component: Home,
        // 某些页面规定必须登录后才能查看 ，可以在router中配置meta，将需要登录的requireAuth设为true，
        meta: {
            requireAuth: true,
        }
    },
    {
        path: '/manage',
        name: 'manage',
        component: Manage,
        // 某些页面规定必须登录后才能查看 ，可以在router中配置meta，将需要登录的requireAuth设为true，
        meta: {
            requireAuth: true,
        }
    },
    {
        path: '/message',
        name: 'message',
        component: Message,
        // 某些页面规定必须登录后才能查看 ，可以在router中配置meta，将需要登录的requireAuth设为true，
        meta: {
            requireAuth: true,
        }
    },
    {
        path: '/login',
        name: 'login',
        component: Login,
        meta: {
            showNav: true
        }
    },
    {
        path: '/qyLogin/:id',
        name: 'qyLogin',
        component: QyLogin,
        meta: {
            showNav: true
        }
    },
    {
        path: '/password',
        name: 'passwordFind',
        component: PasswordFind,
        meta: {
            showNav: true
        }
    },
    {
        path: '/register',
        name: 'register',
        component: Register,
        meta: {
            showNav: true
        }
    },
    {
        path: '/mine',
        name: 'mine',
        component: Mine,
        meta: {
            requireAuth: true,
        }
    },
    {
        path: '/commondityIndex',
        name: 'commondityIndex',
        redirect: '/commondityIndex/cManageIndex',
        component: () => import('../views/commondityManage/CommondityIndex.vue'),
        children: [
            {
                path: 'cManageIndex',
                name: 'cManageIndex',
                component: () => import('../views/commondityManage/index.vue'),
            },
            {
                path: 'addCommondity',
                name: 'addCommondity',
                component: () => import('../views/commondityManage/addCommondity.vue'),
            },
            {
                path: 'cManageDetail/:id',
                name: 'cManageDetail',
                component: () => import('../views/commondityManage/detail.vue'),
            },
            {
                path: 'cManageEdit',
                name: 'cManageEdit',
                redirect: '/commondityIndex/cManageEdit/cBaseinfo/:id',
                component: () => import('../views/commondityManage/editCommondity/CommondityEditIndex.vue'),
                children: [
                    {
                        path: 'cBaseinfo/:id',
                        name: 'cBaseinfo',
                        component: () => import('../views/commondityManage/editCommondity/baseInfo.vue'),

                    },
                    {
                        path: 'cImages/:id',
                        name: 'cImages',
                        component: () => import('../views/commondityManage/editCommondity/images.vue'),
                    },
                    {
                        path: 'cSalesParams/:id',
                        name: 'cSalesParams',
                        component: () => import('../views/commondityManage/editCommondity/salesParams.vue'),
                    },
                    {
                        path: 'cAttrLabel/:id',
                        name: 'cAttrLabel',
                        component: () => import('../views/commondityManage/editCommondity/attrLabel.vue'),
                    },
                    {
                        path: 'cAttrLabelSet',
                        name: 'cAttrLabelSet',
                        component: () => import('../views/commondityManage/editCommondity/attrLabelSet.vue'),
                    },
                    {
                        path: 'cLabel/:id',
                        name: 'cLabel',
                        component: () => import('../views/commondityManage/editCommondity/commondityLabel.vue'),
                    },
                    {
                        path: 'cDetail/:id',
                        name: 'cDetail',
                        component: () => import('../views/commondityManage/editCommondity/detail.vue'),
                    },
                    {
                        path: 'cOthers/:id',
                        name: 'cOthers',
                        component: () => import('../views/commondityManage/editCommondity/others.vue'),
                    }
                ]
            }
        ],
        // 某些页面规定必须登录后才能查看 ，可以在router中配置meta，将需要登录的requireAuth设为true，
        meta: {
            requireAuth: true,
        }
    },
    {
        path: '/brandIndex',
        name: 'brandIndex',
        component: () => import('../views/brandManage/BrandIndex.vue'),
        redirect: '/brandIndex/brandList',
        children: [
            {
                path: 'brandList',
                name: 'brandList',
                component: () => import('../views/brandManage/list.vue'),
            },
            {
                path: 'brandDetail',
                name: 'brandDetail',
                component: () => import('../views/brandManage/detail.vue'),
            }
        ],
        // 某些页面规定必须登录后才能查看 ，可以在router中配置meta，将需要登录的requireAuth设为true，
        meta: {
            requireAuth: true,
        }
    },
    {
        path: '/supplierIndex',
        name: 'supplierIndex',
        component: () => import('../views/supplierManage/SupplierIndex.vue'),
        redirect: '/supplierIndex/supplierList',
        children: [
            {
                path: 'supplierList',
                name: 'supplierList',
                component: () => import('../views/supplierManage/list.vue'),
            },
            {
                path: 'supplierDetail',
                name: 'supplierDetail',
                component: () => import('../views/supplierManage/detail.vue'),
            }
        ],
        // 某些页面规定必须登录后才能查看 ，可以在router中配置meta，将需要登录的requireAuth设为true，
        meta: {
            requireAuth: true,
        }
    },
    {
        path: '/storageIndex',
        name: 'storageIndex',
        component: () => import('../views/storageManage/StorageIndex.vue'),
        redirect: '/storageIndex/sManageIndex',
        children: [
            {
                path: 'sManageIndex',
                name: 'sManageIndex',
                component: () => import('../views/storageManage/index.vue'),
            },
            {
                path: 'sManageTwo/:id',
                name: 'sManageTwo',
                component: () => import('../views/storageManage/two.vue'),
            },
            {
                path: 'sManageThree/:parentId/:id',
                name: 'sManageThree',
                component: () => import('../views/storageManage/three.vue'),
            },
            {
                path: 'sManageFour/:parentId/:shelfid/:id',
                name: 'sManageFour',
                component: () => import('../views/storageManage/four.vue'),
            }
        ],
        // 某些页面规定必须登录后才能查看 ，可以在router中配置meta，将需要登录的requireAuth设为true，
        meta: {
            requireAuth: true,
        }
    },
    {
        path: '/warehousIndex',
        name: 'warehousIndex',
        redirect: '/warehousIndex/wManageIndex',
        component: () => import('../views/warehousingManage/warehousIndex.vue'),
        children: [
            {
                path: 'wManageIndex',
                name: 'wManageIndex',
                component: () => import('../views/warehousingManage/index.vue'),
            },
            {
                path: 'wManageDetail/:keyword',
                name: 'wManageDetail',
                component: () => import('../views/warehousingManage/detail.vue'),
            },
            {
                path: 'wManageSettingList/:keyword/:cmid',
                name: 'wManageSettingList',
                component: () => import('../views/warehousingManage/settingList.vue'),
            },
            {
                path: 'wManageSettingItem/:keyword/:cmid/:type',
                name: 'wManageSettingItem',
                component: () => import('../views/warehousingManage/settingItem.vue'),
            }
        ],
        // 某些页面规定必须登录后才能查看 ，可以在router中配置meta，将需要登录的requireAuth设为true，
        meta: {
            requireAuth: true,
        }
    },
    {
        path: '/recordIndex',
        name: 'recordIndex',
        redirect: '/recordIndex/wRecordIndex',
        component: () => import('../views/warehousingRecord/RecordIndex.vue'),
        children: [
            {
                path: 'wRecordIndex',
                name: 'wRecordIndex',
                component: () => import('../views/warehousingRecord/index.vue'),
            },
            {
                path: 'wRecordList/:keyword',
                name: 'wRecordList',
                component: () => import('../views/warehousingRecord/list.vue'),
            },
            {
                path: 'wRecordDetail',
                name: 'wRecordDetail',
                component: () => import('../views/warehousingRecord/detail.vue'),
            },
        ],
        // 某些页面规定必须登录后才能查看 ，可以在router中配置meta，将需要登录的requireAuth设为true，
        meta: {
            requireAuth: true,
        }
    },
    {
        path: '/purchaseIndex',
        name: 'purchaseIndex',
        component: () => import('../views/purchaseManage/PurchaseIndex.vue'),
        redirect: '/purchaseIndex/pManageIndex',
        children: [
            {
                path: 'pManageIndex',
                name: 'pManageIndex',
                component: () => import('../views/purchaseManage/index.vue'),
            },
            {
                path: 'pManageList/:keyword',
                name: 'pManageList',
                component: () => import('../views/purchaseManage/list.vue'),
            },
            {
                path: 'pManageDetail',
                name: 'pManageDetail',
                component: () => import('../views/purchaseManage/detail.vue'),
            },
            {
                path: 'pManageSet/:id',
                name: 'pManageSet',
                component: () => import('../views/purchaseManage/setttingItem.vue'),
            },
            {
                path: 'pWareList/:id',
                name: 'pWareList',
                component: () => import('../views/purchaseManage/pWareList.vue'),
            },
            {
                path: 'pWareItem/:id',
                name: 'pWareItem',
                component: () => import('../views/purchaseManage/pWareItem.vue'),
            }
        ],
        // 某些页面规定必须登录后才能查看 ，可以在router中配置meta，将需要登录的requireAuth设为true，
        meta: {
            requireAuth: true,
        }
    },
    {
        path: '/companyIndex',
        name: 'companyIndex',
        component: () => import('../views/companyManage/CompanyIndex.vue'),
        redirect: '/companyIndex/companyManageDetail',
        children: [
            {
                path: 'companyDetail/:qyid',
                name: 'companyDetail',
                component: () => import('../views/companyManage/companyDetail.vue'),
            },
            {
                path: 'userDetail/:openid/:qyid/:id',
                name: 'userDetail',
                component: () => import('../views/companyManage/userDetail.vue'),
            },
            {
                path: 'userList/:qyid',
                name: 'userList',
                component: () => import('../views/companyManage/userList.vue'),
            },
            {
                path: 'companyList',
                name: 'companyList',
                component: () => import('../views/companyManage/companyList.vue'),
            },
        ],
        // 某些页面规定必须登录后才能查看 ，可以在router中配置meta，将需要登录的requireAuth设为true，
        meta: {
            requireAuth: true,
        }
    },

]

// 
const router = new VueRouter({
    // mode: 'history',
    routes,
    scrollBehavior() {
        // to, from, savedPosition
        return { x: 0, y: 0 }
    }
})

// 设置访问环境
if (/wxwork/.test(navigator.userAgent.toLowerCase())) {
    // 在企业微信中打开
    store.commit("setUserAgent", 'qyWechat');
} else {
    // 非企业微信环境中打开
    store.commit("setUserAgent", 'other');
}

// 用户登录形式，默认为网页0
let userLoginType = store.state.userLoginType

router.beforeEach((to, from, next) => {
    //根据字段判断是否路由过滤
    let OPENID = storage.get('OPENID');
    if (to.matched.some(record => record.meta.requireAuth)) {
        if (OPENID != '' && OPENID != null) {
            next()
        } else {
            if (userLoginType == 1) {
                //防止无限循环
                if (to.name === 'qyLogin') {
                    next();
                    return
                }
                next({
                    path: "/qyLogin/1",
                });
            } else {
                //防止无限循环
                if (to.name === 'login') {
                    next();
                    return
                }
                next({
                    path: "/login",
                });
            }

        }
    } else {
        if (OPENID != '' && OPENID != null) {
            next({
                path: "/home",
            });
        } else {
            next()//若点击的是不需要验证的页面,则进行正常的路由跳转
        }

    }
});


// 将router对象传入到Vue实例中
export default router